import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/teach-info.css"

import { HandleImages } from "../components/functions"
import Img from "gatsby-image"
import bike from "../images/bike.webm"
import door from "../images/door.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"
import arrow from "../images/arrow.webm"
import student from "../images/student.webm"

const style = {}
var height
var position

class LearnInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active:true
    }
  
  }

  
  componentDidMount() {
      var current=this;
    console.log('mount',this.state.active);
    this.setState({
      safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
  })
   /* setInterval(function() {
        current.setState({
          active: !current.state.active
        });
      }, 5000)*/
  }


 
  render() {
     
    return (
      <div className="teach-info-wrapper">
                      <div className="pre-top">
          <h3>Hands-on experience with real world tools <br/>drives concepts home 
</h3>
              <span>
Enrich curriculum with a pre-built cyber range.</span></div>
        <div className="top">
          <div className="left">
            {" "}

         
            <OnVisible className="video-wrapper" >
              {this.state.visible && (
                      this.state.safari?<HandleImages name="arrowS"/>:        <video autoplay="true" loop="true" muted="true">
                         <source src={arrow} type="video/webm" />
                         </video>
              )}
            </OnVisible>
            
           
           
    
          </div>
          <div>
              
              <p>ISC<sup>2</sup> estimates that over <strong>4 million </strong>cyber professionals will be needed to fill the widening industry skills gap.</p>
              
            </div>
            
 
        </div>
 

        <div className="bottom">
            
          <div className="left">

         
          <div>
              <span className="quotation">“</span>
              <span className='quote'>Employers find graduates from many programs to be lacking in fundamentals knowledge, practical experience, and critical soft skills.</span>
              <span className='source'>Center of Strategic and Internationals Studies</span>
              <p>Indeed, the future is bright for graduates <strong>if</strong> they are well prepared.</p></div>
           
          </div>
          <div className="right">
          <div><h3>The cyber security field is rich with job opportunity! </h3><span>There are openings for security work roles in companies of all sizes and industries.</span> </div>
      <div>
         <HandleImages name="covid2020"/>
            <p>The unexpected shift to distance learning has introduced challenges to educators and students. But, it is expected that online teaching will continue to blend with classroom activity long after pandemic issues subside.</p>
         
         </div>
          </div>
        </div>




   
         
        <div className="last">
        <OnVisible className="video-wrapper">
                


                {this.state.safari?<HandleImages name="student"/>:        <video autoplay="true" loop="true" muted="true">
<source src={student} type="video/webm" />
</video>}
              </OnVisible>
      
      <div>
      <h3>Now is the time</h3>
        <p>
      for cyber educators to integrate a cyber range lab into their course material.
      </p></div>

      <div>
<ul>
<li>Build the bridge between cyber concepts and the practical application of cyber security skills</li>

<li>Universities, bootcamps, trade schools, and high schools place confidence in Project Ares because the cyber range comes with integrated learning exercises that easily align to course syllabi</li>
<li>No technical maintenance of a cyber range needed</li>

<li>Hands-on keyboard practice with real world tools, techniques, and adversaries prepare studetns to jump start their careers in IT cyber security</li>



</ul>

      </div>
         
          </div>
      </div>
    )
  }
}

export default LearnInfo
